// extracted by mini-css-extract-plugin
export var readonly = "_hq-1";
export var star = "_hq-0";